import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {Rule} from "./models/rule.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozArray} from "../persistence-layer/bringoz-array";

angular
  .module('bringoz.admin.ruleEngine')
  .factory('$rules', rulesObjectFactory);

export type $rulesFactory = () => BringozArray<Rule>;

function rulesObjectFactory($bringozFactory: $bringozFactory,
                            rulesAPI: BringozApi,
                            Rules_DS: DataStoreConfig) {

  function $rules() {
    return $bringozFactory<Rule>(null, rulesAPI, Rules_DS)
  }

  return $rules;

}
